import FigureEditingScene from "./FigureEditingScene";
import FigurePanelViewer from "./FigurePanelViewer";
import PanelPreview from "./PanelPreview";
import usePresentSelector from './usePresentSelector';
import { useMemo } from 'react';
import { createStore } from 'redux';
import NoFigureSelectedScene from './NoFigureSelectedScene';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRef } from 'react';
import FigureEditorContainer from './FigureEditorContainer';
import CanvasFigure from './CanvasFigure';
import CropInsertionSelector from './CropInsertionSelector';
import G from './Getters';
import CropDragProvider from './CropDragProvider';
import SelectedItemProvider from './SelectedItemProvider';
import FigureInteractionProvider from './FigureInteractionProvider';
import TemporaryCellValueProvider from './TemporaryCellValueProvider';


const initialState = { 
  cellValueInput:""
}

function simpleReducer(state,action){
  return { ...state, ...action };
}

export default function FigureScene({
  setSvg, 
  svg, 
  setMode, 
  showSearchBar, 
  selectedFigurePanelContext,
  setSelectedFigurePanelContext
}){

  let figurePanelId = selectedFigurePanelContext.figurePanelId; 

 
  let userCanEdit = true;


  if( userCanEdit ){

    return <FigureEditingScene {...{

      setSvg, 
  svg, 
  setMode, 
  showSearchBar, 
  selectedFigurePanelContext,
  setSelectedFigurePanelContext

    }}/>


  }else{
    return <FigurePanelViewer {...{
      figurePanelId,
        setSvg,
        svg,
    }}/>
  }





  
}
